<template>
  <div class="goods-box my-form">
    <div class="registered">
        <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false">
            <van-field
                v-model="form.Booth"
                type="text"
                name="Booth"
                label="Booth"
                placeholder="Please enter booth"
                required
                disabled
                :rules="[{ required: true, message: 'Please enter booth' }]"
            />
            <van-field
                v-model="form.CompName"
                type="text"
                name="Company"
                label="Company"
                placeholder="Please enter company"
                required
                :rules="[{ required: true, message: 'Please enter company' }]"
            />
            <van-field
                v-model="form.Username"
                name="Name"
                label="Name"
                placeholder="Please enter your name"
                required
                :rules="[{ required: true, message: 'Please enter your name' }]"
            />
            <template v-if="user.phone">
              <van-field
                v-model="form.Phone"
                type="number"
                name="pattern"
                label="Phone"
                maxlength="11"
                placeholder="Please enter your phone"
                required
                :rules="[{ pattern, message: 'Please enter your phone' }]"
                disabled
              />
            </template>
            <template v-else>
              <van-field
                  v-model="form.Phone"
                  type="number"
                  name="pattern"
                  label="Phone"
                  maxlength="11"
                  placeholder="Please enter your phone"
                  required
                  :rules="[{ pattern, message: 'Please enter your phone' }]"
              />
              <van-field
                  v-model="code"
                  center
                  clearable
                  label="Code"
                  maxlength="6"
                  placeholder="Please enter code"
                  required
                  :rules="[{ required: true, message: 'Please enter code' }]"
                  >
                  <template #button>
                    <span class="code" v-if="newTimer">{{ newCount || 0}}s</span>
                    <span class="sendcode code" v-else @click="getCode">send</span>
                  </template>
              </van-field>
            </template>
            <van-field
                v-model="form.Introduction"
                rows="4"
                type="textarea"
                class="intro_cell"
                maxlength="200"
                placeholder="Please enter remarks"
                />
            <div>
            </div>

            <div class="vant-btn">
                <van-button round block type="info"  native-type="submit">
                  Submit
                </van-button>
            </div>
        </van-form>
    </div>
     

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gql from 'graphql-tag';

export default {
  data() {
    return {
      form: {
        Booth:'', // 展位号
        Username: "", // 姓名
        Phone: "", // 手机号
        CompName: "", // 公司名
        Introduction:'', // 备注
      },
      //验证码
      code:'',
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      codeKey:'',
      //验证码
      pattern: /^1[3456789]\d{9}$/, // 校验手机号

      
    };
  },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      userId:"getUserId",
      hostInfo:"getHostInfo",
      exhibitionId:'getExhibitionId'
    }),
    mutationGql(){
        return gql`mutation ($boothClaim: BoothClaimCreate!) {
                    boothClaim{
                        create(boothClaim: $boothClaim) {
                            code
                            message
                            result
                        }
                    }
                }`
    },
  },
  created() { 
      this.init();
  },
  methods: {
    ...mapActions({
      LinkToRegFinsh:'linkTo/LinkToRegFinsh',
      patchUser:'my/patchUser',
      sendCode:'my/sendCode',
      validateCode:'my/validateCode',
      putPhone:'my/putPhone',
      regUser:'my/regUser',
    }),
    async init(){
        this.form.Booth = this.$route.query.booth;
        let exhibitionId = this.$route.params.id;
        console.log(exhibitionId,'exhibitionId')
        this.$store.commit("setExhibitionId",exhibitionId);
        await this.$Myapollo.getExhibitionInfo(this,exhibitionId,this.userId);
        await this.$Myapollo.getUserInfo(this);
        this.form.Username = this.user.name;
        this.form.Phone = this.user.phone;
        this.form.CompName = this.user.company;
    },
    async onSubmit(){
        if(!this.user.phone){ // 手机号没认证
            let checkRes =  await this.Checkphone();
            if(!checkRes) {
            return;
            }
        }
        let body = {
            userId:this.user.userId,
            hostId:this.hostInfo.id,
            exhibitionId:this.exhibitionId,
            hall:'',
            boothCode:this.form.Booth,
            name:this.form.Username,
            compName:this.form.CompName,
            phone:this.form.Phone,
            introduction:this.form.Introduction,
        };
        this.$apollo.mutate({
            mutation: this.mutationGql,
            variables: {
                boothClaim:body,
            },
            client: 'api'
        })
        .then(res => {
            if(res.data.boothClaim.create.result){
                this.$toast.success('success');
                setTimeout(()=>{
                    this.$router.go(-1);
                },2000)
            } else {
                this.$toast.fail(res.data.boothClaim.create.message);
            }
        })
        .catch((error) => {
            this.$toast.fail('fail');
            console.error(error)
        })
    },


    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 获取手机号验证码
    async getCode(){
      console.log(this.form.Phone,'123213')
      if (!this.validatorPhone(this.form.Phone)) {
        this.$toast.fail('error phone')
        return;
      } else {
        this.newDownTime();
        let res = await this.sendCode({
          PhoneNumber: this.form.Phone
        });
        if (res.result) {
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail('fail')
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.code
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail('Validation failed')
          this.resetDown();
          resolve(false);
        }
      })
    },


    resetDown(){ // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin:.45rem 0;
  }
  .registered {
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    ::v-deep .reg_from{
      .intro_title{
        height: 0.77rem;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;
        font-size: 0.3rem;
        color: #333;
      }
      .van-cell{
        padding: 0 0.3rem;
        height: 0.98rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        &.intro_cell{
          height: 2.6rem;
        }
        &.cate_cell{
          .van-cell__title{
            flex: 0.4;
          }
          
          .van-cell__value{
            text-align: left;     
            p{
              font-size: 0.3rem;
              span{
                font-size: 0.3rem;
                color:#ff5c00 ;
              }
            }
          }
        }
        .van-field__label{
          color: #333;
        }
        .van-cell__value{
          .van-field__control{
             color:#666666;
          }
          span{
            font-size: .3rem;
          }
        }
      }
    }
    

    }
}
</style>